import { AppRegistry } from 'react-native';
import './common/errorTracker';
import Main from './components/Main';

AppRegistry.registerComponent('digg', () => Main);
AppRegistry.runApplication('digg', {
  rootTag: document.getElementById('root'),
});
